import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { ArrowRight, Banknote, ShieldCheck, Smartphone, Star } from "lucide-react";

const ForProviders = () => (
  <div className="min-h-screen bg-background">
    <Navbar />
    <main>
      <section className="grain-bg py-20">
        <div className="container-page">
          <div className="tiny-label mb-3">Pro prádelny</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 max-w-3xl leading-[1.05]">
            Vyperte za sebe i za sousedy. <span className="text-sky-600">Provize jen 15 %.</span>
          </h1>
          <p className="mt-5 text-slate-600 max-w-2xl text-lg">
            Stačí pračka, sušák a chuť pomoct. Posíláme vám objednávky z okolí, postaráme se o platbu, marketing a podporu.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/registrace?role=provider" className="cta-primary" data-testid="provider-page-register">
              Zaregistrovat se <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <section className="container-page py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {[
          { icon: Smartphone, title: "Objednávky přímo do telefonu", desc: "Notifikace o nových zakázkách v okolí. Jedním klikem přijmete." },
          { icon: Banknote, title: "Platba předem", desc: "Platforma drží peníze a po dokončení vám je vyplatí. Žádné nedoplatky." },
          { icon: ShieldCheck, title: "Pojištění a fotodokumentace", desc: "Foto pytle při převzetí i doručení – jistota pro obě strany." },
          { icon: Star, title: "Budujte si reputaci", desc: "Hodnocení zákazníků posiluje viditelnost vaší prádelny." },
        ].map((b, i) => (
          <Card key={i} className="p-6">
            <div className="w-11 h-11 rounded-xl bg-sky-100 text-sky-700 grid place-items-center mb-3"><b.icon className="w-5 h-5" /></div>
            <h3 className="font-display font-bold">{b.title}</h3>
            <p className="text-sm text-slate-600 mt-1">{b.desc}</p>
          </Card>
        ))}
      </section>

      <section className="container-page pb-20">
        <Card className="p-8 bg-slate-900 text-white">
          <h2 className="font-display text-2xl font-bold">Příklad výdělku</h2>
          <div className="mt-5 grid md:grid-cols-4 gap-4 text-sm">
            <div><div className="text-slate-400 text-xs uppercase tracking-wider">Zakázka</div><div className="font-display text-2xl font-bold">10 kg</div></div>
            <div><div className="text-slate-400 text-xs uppercase tracking-wider">Cena pro zákazníka</div><div className="font-display text-2xl font-bold">600 Kč</div></div>
            <div><div className="text-slate-400 text-xs uppercase tracking-wider">Provize platformy 15%</div><div className="font-display text-2xl font-bold text-rose-300">−90 Kč</div></div>
            <div><div className="text-slate-400 text-xs uppercase tracking-wider">Vaše odměna</div><div className="font-display text-3xl font-extrabold text-emerald-300">510 Kč</div></div>
          </div>
        </Card>
      </section>
    </main>
    <Footer />
  </div>
);

export default ForProviders;
